import { render, staticRenderFns } from "./EditCategoryPropertyModal.vue?vue&type=template&id=6a3b1036&scoped=true"
import script from "./EditCategoryPropertyModal.vue?vue&type=script&lang=js"
export * from "./EditCategoryPropertyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3b1036",
  null
  
)

export default component.exports